import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
//import ChuahoanthanhImg from "assets/img/incomplete.png";
import ThongkedonvicosoTT from "components/Dashboard/ThongkedonvicosoTT.js";
import Dangkiemthongkephuongtien from "components/Dashboard/DKthongkephuongtien.js";
import Chuahoanthanh from "components/Dashboard/Chuahoanthanh.js";
import Phuongthucvantai from "components/Dashboard/Phuongthucvantai.js";
import Thongkevantaihanghoa from "components/Dashboard/Thongkevantaihanghoa.js";
import Thongkevantaihanhkhach from "components/Dashboard/Thongkevantaihanhkhach.js";
import Thiphanvantaihanhkhach from "components/Dashboard/Thiphanvantaihanhkhach.js";
import Tylebaocao from "components/Dashboard/Tylebaocao.js";
import Homeimg from "assets/img/home.png";
import { Tooltip } from "@material-ui/core";
const BlueOnGreenTooltip = withStyles({
  tooltip: { backgroundColor: "#c2c800" },
})(Tooltip);
import Phuongtiengiaothong from "components/Dashboard/Phuongtiengiaothong.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/dashBoardth.js";

const useStyles = makeStyles(styles);
export default function Dashboard() {
  const classes = useStyles();
  const [thangnam, setThangnam] = React.useState(dayjs().subtract(1, "month"));
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [phanloaisoluong, setPhanloaisoluong] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  let history = useHistory();
  const gotohome = () => {
    history.push("/");
  };
  const getdangkiem = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/BaoCao/bcphuluc14qd342025?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuongtien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphanloaisoluong = () => {
    var url = Config.backend + "/api/Donvi/dashpldonvi?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhanloaisoluong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getdangkiem();
    getphanloaisoluong();
  }, []);
  React.useEffect(() => {
    getdangkiem();
    getphanloaisoluong();
  }, [thangnam]);
  return (
    <div className={classes.dashboard_th}>
      <div className={classes.dashboard_header}>
        <div className={classes.header_title}>
          <span>DASHBOARD ĐIỀU HÀNH</span>
        </div>
        <div className={classes.header_title_left}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "30px",
                  color: "white",
                },
                label: { color: "white" },
                svg: { color: "white" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white",
                  },
                },
              }}
            />
          </LocalizationProvider>
        </div>
        <div className={classes.header_home_button}>
          <BlueOnGreenTooltip
            title={<a className={classes.tooltip}>Quay lại trang chủ</a>}
            placement="top-start"
          >
            <img src={Homeimg} className={classes.img} onClick={gotohome}></img>
          </BlueOnGreenTooltip>
        </div>
      </div>
      <div className={classes.dashboard_main}>
        <div className={classes.row}>
          <GridContainer
            style={{ marginTop: "10px", width: "100%", marginLeft: 5 }}
          >
            <GridItem xs={12} sm={10} md={4}>
              <div className={classes.row}>
                <div className={classes.card}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>PHƯƠNG THỨC VẬN TẢI</span>
                    </div>
                  </div>
                  <div className={classes.card_body_top}>
                    <Phuongthucvantai thangnam={thangnam} />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
            <GridItem xs={12} sm={10} md={3}>
              <div className={classes.row}>
                <div className={classes.card}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>THỊ PHẦN VẬN TẢI HÀNH KHÁCH</span>
                    </div>
                  </div>
                  <div className={classes.card_body_top}>
                    <Thiphanvantaihanhkhach thangnam={thangnam} />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
            <GridItem xs={12} sm={10} md={5}>
              <div className={classes.row}>
                <div className={classes.card}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>PHƯƠNG TIỆN VTHK ĐƯỜNG BỘ</span>
                      <span style={{ marginLeft: "3vw" }}>
                        PHƯƠNG TIỆN VTHH ĐƯỜNG BỘ
                      </span>
                    </div>
                  </div>
                  <div className={classes.card_body_top}>
                    <div className={classes.card_body_vantai_right}>
                      <Thongkevantaihanhkhach thangnam={thangnam} />
                    </div>
                    <div className={classes.card_body_vantai}>
                      <Thongkevantaihanghoa thangnam={thangnam} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.row}>
          <GridContainer
            style={{ marginTop: "5px", width: "100%", marginLeft: 5 }}
          >
            <GridItem xs={12} sm={10} md={6}>
              <div className={classes.row}>
                <div className={classes.card} style={{ height: "220px" }}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>THỐNG KÊ ĐƠN VỊ, CƠ SỞ, TRUNG TÂM</span>
                    </div>
                  </div>
                  <div className={classes.card_body_slst}>
                    <ThongkedonvicosoTT phanloaisoluong={phanloaisoluong} />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
            <GridItem xs={12} sm={10} md={6}>
              <div className={classes.row}>
                <div className={classes.card} style={{ height: "220px" }}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>
                        PHƯƠNG TIỆN GIAO THÔNG ĐƯỜNG BỘ ĐƯỢC CẤP ĐĂNG KÝ
                      </span>
                    </div>
                  </div>
                  <div className={classes.card_body_slst}>
                    <Phuongtiengiaothong />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.row}>
          <GridContainer
            style={{ marginTop: "5px", width: "100%", marginLeft: 5 }}
          >
            <GridItem xs={12} sm={10} md={6}>
              <div className={classes.row}>
                <div className={classes.card} style={{ height: "220px" }}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>CHƯA THỰC HIỆN BÁO CÁO</span>
                    </div>
                  </div>
                  <div className={classes.card_body_slst}>
                    <Chuahoanthanh thangnam={thangnam} />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
            <GridItem xs={12} sm={10} md={6}>
              <div className={classes.row}>
                <div className={classes.card} style={{ height: "220px" }}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>TỶ LỆ BÁO CÁO</span>
                    </div>
                  </div>
                  <div className={classes.card_body_slst}>
                    <Tylebaocao thangnam={thangnam} />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.row}>
          <GridContainer
            style={{ marginTop: "5px", width: "100%", marginLeft: 5 }}
          >
            <GridItem xs={12} sm={10} md={12}>
              <div className={classes.row}>
                <div className={classes.card} style={{ height: "400px" }}>
                  <div className={classes.card_header_center}>
                    <div className={classes.vantai_header}>
                      <span>PHƯƠNG TIỆN ĐĂNG KIỂM</span>
                    </div>
                  </div>
                  <div className={classes.card_body_slst}>
                    <Dangkiemthongkephuongtien phuongtien={phuongtien} />
                  </div>
                </div>
              </div>
              <div className={classes.row}></div>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
